module.exports = __webpack_public_path__ + "4e595ab54f0887b1bb441b12ebae5ffe.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/graviton_-_agudaboldunicase-webfont.woff2
// module id = 1313
// module chunks = 28